<template>
  <div class="speech-playlist">
    <PlayerPlaylist
      v-if="playlist.length"
      ref="list"
      :playlist="playlist"
      :playing="!paused && reading"
      :track="track"
      @play="play" />
    <SystemInfo
      v-else
      icon="maps-and-location-5">
      <p>
        {{ t('playlistEmpty') }}
      </p>
    </SystemInfo>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PlayerPlaylist from '@/components/ui/Player/PlayerPlaylist'

export default {
  name: 'SpeechPlaylist',
  components: {
    PlayerPlaylist
  },
  computed: {
    ...mapGetters({
      playlist: 'speech/playlist',
      track: 'speech/currentIndex',
      paused: 'speech/paused',
      reading: 'speech/reading'
    })
  },
  watch: {
    track (val, old) {
      if (val !== old && this.$refs && this.$refs.list) this.scrollTo(val)
    }
  },
  methods: {
    ...mapActions({
      playTrackByIndex: 'speech/playTrackByIndex',
      pause: 'speech/pause',
      resume: 'speech/resume'
    }),
    play (n) {
      if (this.track === n) {
        if (this.paused) this.resume()
        else this.pause()
      } else {
        this.playTrackByIndex(n)
        this.scrollTo(n)
      }
    },
    scrollTo (n) {
      if (this.$refs && this.$refs.list) this.$refs.list.scrollTo(n)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.track !== 0) this.scrollTo(this.track)
    })
  }
}
</script>

<style lang="scss">
.speech-playlist {
  height: 130px;
}
</style>
